import { ioParams } from 'dibs-fastly/exports/imageOptimizations.ts';

export const addParams = (
    url: string | undefined | null,
    width: string | undefined,
    height?: string | undefined
): string | null => {
    const params = ioParams({
        height: height as `${number}` | undefined,
        width: width as `${number}` | undefined,
        fit: 'bounds',
        'resize-filter': 'bilinear',
        format: 'pjpg',
        dpr: '2',
        auto: 'webp',
        optimize: 'high',
        precrop: '1:1',
    }).toQuery();
    return url ? url + params : null;
};
